module.exports = __webpack_public_path__ + "img/info4.57aa34a2.png";